import {
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover
} from '@material-ui/core';
import { authRef } from 'api';
import WalletIcon from 'mdi-react/AccountBalanceWalletOutlineIcon';
import AccountIcon from 'mdi-react/AccountIcon';
import LogoutIcon from 'mdi-react/LogoutIcon';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Avatar from './Avatar';
import { PrimaryButton } from './Buttons/PrimaryButton';

export default function HeaderAuthHandler({ history }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);
  const id = open ? 'profile-popover' : undefined;

  let { authenticated, firestoreUser } = useSelector(state => state.authState);

  if (authenticated) {
    return (
      <div style={{ cursor: 'pointer' }}>
        <Avatar
          image={firestoreUser.photo_url}
          aria-describedby={id}
          onClick={handleClick}
        />
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <div>
            <div
              style={{
                padding: 20
              }}
            >
              {/* TODO: We have to craete title component too */}
              <div>{firestoreUser.name}</div>
              <div>Roll No: {firestoreUser.roll}</div>
              <div>Wallet: {firestoreUser.wallet} exams</div>
            </div>
            <Divider />
            <ListItem
              button
              onClick={() => {
                setAnchorEl(null);
                history.push('/profile');
              }}
            >
              <ListItemIcon>
                <AccountIcon />
              </ListItemIcon>
              <ListItemText primary="View Profile" />
            </ListItem>
            <ListItem
              button
              onClick={() => {
                setAnchorEl(null);
                history.push('/pricing');
              }}
            >
              <ListItemIcon>
                <WalletIcon />
              </ListItemIcon>
              <ListItemText primary="Wallet Topup" />
            </ListItem>
            <ListItem
              button
              onClick={() => {
                setAnchorEl(null);
                authRef.signOut();
                dispatch({ type: 'LOGOUT' });
              }}
            >
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </div>
        </Popover>
      </div>
    );
  } else {
    return (
      <PrimaryButton
        marginright="0"
        onClick={() => history.push('/login')}
        small="true"
      >
        Login
      </PrimaryButton>
    );
  }
}
